import React from 'react'

import { useSubscriptionsQueries } from 'src/hooks/services/microsoft/queries/useSubscriptionsQuery'
import { useTenantsQuery } from '~/hooks/services/servicenow/queries/useTenantsQuery'

import { isExpiringSoon } from 'src/utils/subscriptions'

import moment from 'moment'
import { IoWarningOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'

import { Tile, TileFooter, TileHeader, TileListContent, TileListItem } from '../Tile'

const ExpiringLicensesTile: React.FC = () => {
  const navigate = useNavigate()
  const { data: tenants = [], isLoading: isTenantsLoading } = useTenantsQuery()
  const queries = useSubscriptionsQueries(tenants.map((tenant) => tenant.id))

  const subscriptionsWithTenants = queries
    .map((query, index) => {
      const tenant = tenants[index]
      return (query.data ?? []).map((subscription) => ({
        ...subscription,
        tenant
      }))
    })
    .flat()
    .filter((sub) => isExpiringSoon(sub) && !sub.AutoRenewEnabled)

  return (
    <Tile onMouseDown={() => navigate('/subscriptions?filter=expiring')}>
      <TileHeader loading={queries.some((query) => query.isLoading) || isTenantsLoading}>
        <TileHeader.Title>{subscriptionsWithTenants.length}</TileHeader.Title>
        <TileHeader.Subtitle>Microsoft 365 Licenses Expiring Soon</TileHeader.Subtitle>
        <TileHeader.Item>
          <IoWarningOutline className="h-10 w-10 text-th-warning" />
        </TileHeader.Item>
      </TileHeader>
      <TileListContent limit={3} bordered>
        {subscriptionsWithTenants.map((sub) => (
          <TileListItem key={sub.Id}>
            <TileListItem.Title>{sub.FriendlyName}</TileListItem.Title>
            <TileListItem.Subtitle>
              {sub.tenant.name}
              <span>Expires {moment(sub.CommitmentEndDate).format('DD/MM/YYYY')}</span>
            </TileListItem.Subtitle>
          </TileListItem>
        ))}
      </TileListContent>
      {subscriptionsWithTenants.length > 3 && <TileFooter>View {subscriptionsWithTenants.length - 3} more...</TileFooter>}
    </Tile>
  )
}

export default ExpiringLicensesTile
